
export default [
    {
        path: '/app',
        name: 'app.dashboard',
        components: {
            authenticated: () => import(/* webpackChunkName: "app-dashboard" */ './../views/App/Dashboard.vue'),
            unauthenticated: () => import(/* webpackChunkName: "app-login" */ './../views/Auth/Login.vue')
        },
        meta: {
            auth: true,
            permition: ['S', 'A', 'C', 'U']
        }
    }
]
